var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 9C4 7.90625 4.875 7 6 7H18C19.0938 7 20 7.90625 20 9V17C20 18.125 19.0938 19 18 19H6C4.875 19 4 18.125 4 17V9ZM5.5 9V9.71875L10.875 14.125C11.5312 14.6562 12.4375 14.6562 13.0938 14.125L18.5 9.71875V9C18.5 8.75 18.25 8.5 18 8.5H6C5.71875 8.5 5.5 8.75 5.5 9ZM5.5 11.6562V17C5.5 17.2812 5.71875 17.5 6 17.5H18C18.25 17.5 18.5 17.2812 18.5 17V11.6562L14.0625 15.2812C12.8438 16.2812 11.125 16.2812 9.90625 15.2812L5.5 11.6562Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.4bda019f32cc221036306d9b58cc9d7b.svg";
export { ForwardRef as ReactComponent };